// src/theme.js
import { createTheme } from '@mui/material/styles';
import { nlNL } from '@mui/x-data-grid/locales';

const theme = createTheme(
  {
    palette: {
      primary: {
        main: '#3d6cb4', // Customize primary color // blue
        // light: will be calculated from palette.primary.main,
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        main: '#bc358d', // Customize secondary color // pink
      },
      background: {
        default: '#f5f5f5', // Customize background color
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h1: {
        fontSize: '2.5rem',
      },
      h2: {
        fontSize: '2rem',
      },
      body1: {
        fontSize: '1rem',
      },
    },
    spacing: 8, // This sets the base spacing for padding, margins, etc.
  },
  nlNL // Voor Nederlandse vertalingen
);

export default theme;
